import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Button } from '../../../components/ui/button';
import { Save } from 'lucide-react';

export function CommissionSettings({ data, setData, isSaving, onSave }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-slate-900 font-[Poppins]">Commission Settings</h3>
      </div>
      
      <div className="space-y-6">
        <div>
          <Label>Global Commission Rate (%)</Label>
          <div className="flex items-center gap-4 mt-2">
            <Input
              type="number"
              min="0"
              max="100"
              value={data.global_rate}
              onChange={(e) => setData(prev => ({ 
                ...prev, 
                global_rate: parseFloat(e.target.value) || 0 
              }))}
              className="w-32 h-12"
              data-testid="commission-input"
            />
            <span className="text-slate-500">%</span>
          </div>
          <p className="text-xs text-slate-500 mt-2">
            This is the default commission taken from each booking.
          </p>
        </div>
        
        <div className="bg-stone-50 rounded-xl p-4">
          <p className="text-sm text-slate-600">
            <strong>Example:</strong> If commission is {data.global_rate}% and a booking costs ₱1,000:
          </p>
          <ul className="text-sm text-slate-600 mt-2 space-y-1">
            <li>• Platform receives: ₱{(1000 * data.global_rate / 100).toFixed(2)}</li>
            <li>• Provider receives: ₱{(1000 - 1000 * data.global_rate / 100).toFixed(2)}</li>
          </ul>
        </div>
        
        <Button 
          onClick={onSave}
          disabled={isSaving}
          className="bg-slate-900 hover:bg-slate-800"
          data-testid="save-commission-btn"
        >
          <Save className="w-4 h-4 mr-2" />
          {isSaving ? 'Saving...' : 'Save Commission Settings'}
        </Button>
      </div>
    </div>
  );
}
